import React, {useState, useEffect, useRef} from "react";
import styled from "styled-components";
import iconLoading from "assets/icons/icon_loading.gif";

export const Observer = (props) => {
	const self = useRef();

	useEffect(() => {
		if(props.isActive) {
			const threshold = props.threshold || 0.95;
			const observer = new IntersectionObserver((entries, observer) => {
				const setActive = (entry, state) => {
					if(state) {
						observer.observe(entry.target);
					} else {
						observer.unobserve(entry.target)
					}
				};
				entries.forEach(entry => {
					if(entry.intersectionRatio >= threshold) {
						if(props.onVisible) {
							props.onVisible(entry, (state) => {setActive(entry, state)});
						}
					} else if(entry.intersectionRatio == 0) {
						if(props.onHidden) {
							props.onHidden(entry, (state) => {setActive(entry, state)});
						}
					}
				});
			}, {threshold : threshold})
			observer.observe(self.current);
			return () => {
				observer.disconnect();
			};
		}
	}, [props]);

	const className = (props.isLoading && props.isActive !== false) ? "loading" : "";
	return (
		<Wrapper ref={self} className={className}></Wrapper>
	)
};

const Wrapper = styled.div`
	&			{display:block; height:0}
	&.loading	{height:60px; background: url(${iconLoading}) no-repeat center center / 50px; background-color: inherit}
`;

export default Observer;